import React from "react";
import gallery1 from "../../assets/gallery1.jpg";
import gallery2 from "../../assets/gallery2.jpg";
import gallery3 from "../../assets/gallery3.jpg";
import gallery4 from "../../assets/gallery4.jpg";
import gallery5 from "../../assets/gallery5.jpg";
import gallery6 from "../../assets/gallery6.jpg";
import gallery7 from "../../assets/gallery7.jpg";
import gallery8 from "../../assets/gallery8.jpg";
import gallery9 from "../../assets/gallery9.jpg";


function Gallery() {
  
  const images = [
    gallery1,gallery2,gallery3,gallery4,gallery5,gallery6,gallery7,gallery8,gallery9
  ];

  return (
    <div style={{ padding: "30px", backgroundColor: "#ffffff" }}>
      
      <h2 style={{  textAlign: "center", fontSize: "30px",color: "#EC1C24",marginBottom: "30px", fontWeight: "bold",}}>
        Our Gallery
      </h2>

      {/*grid */}
      <div style={{display: "flex",flexWrap: "wrap",   justifyContent: "center",gap: "20px",}}  >

        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Gallery ${index + 1}`}
            style={{
              width: "310px",
              height: "210px",
              objectFit: "cover",
              borderRadius: "12px",
              border: "1px solid #ddd",
           
            }}/> ))}

      </div>
    </div>
  );
}

export default Gallery;
